import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  Image,
  Carousel,
  Button,
} from "react-bootstrap";
import { useLocation } from "react-router-dom";
import config from "../../services/apiConfig";
import { apiPaths } from "../../services/apiPath";
import { AWS_URL } from "../../assets/Constants";
import Footer from "../../components/UI/Footer";
import ResponsiveNavBar from "../../components/UI/ResponsiveNavBar";
import EOIPage from "../../components/UI/EOI/index";
import Modal from "react-bootstrap/Modal";
import "./style.css";  // Updated CSS file for modern design
import ChatBox from "../../components/Chatbox/chatbox";
import moment from "moment";


const SharedOutlet = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isOpenEOIModal, set_isOpenEOIModal] = useState(false);
  const [vendorStatus, setVendorStatus] = useState(null);
  const location = useLocation();
  const [firebaseHashcode , setFirebaseHashcode] = useState(null);
  const [isLinkExpired, setIsLinkExpired] = useState(false);

  const handleClose = () => {
    set_isOpenEOIModal(false);
  };

  const handleOpen = () => {
    set_isOpenEOIModal(true);
  };

  const useQuery = () => {
    return new URLSearchParams(location.search);
  };

  const handleDocumentClick = async (docType) => {
    try {
      const hashcode = query.get("hashcode");

      await axios.post(
        config.BASE_URI + apiPaths.adminData,
        {
          payload: {
            body: {
              query_type: "update-document-click",
              document_type: docType,
              hashcode: hashcode,
            },
          },
        }
      );
      console.log(`Document ${docType} click logged successfully.`);
    } catch (err) {
      console.error("Error logging document click:", err.message);
    }
  };

  const query = useQuery();
  const hashcode = query.get("hashcode");
  if (firebaseHashcode === null){

  
  setFirebaseHashcode(hashcode)
  }


 const handleVendorStatus = async (status) => {
  try {
    const response = await axios.post(
      config.BASE_URI + apiPaths.adminData,
      {
        payload: {
          body: {
            query_type: "update_vendor_status_share_a_link",
            status: status,
            hashcode: hashcode,
          },
        },
      }
    );

    if (response.data.success) {
      alert(`Vendor successfully ${status}.`);

      setVendorStatus(status);  // 👈 update local state
      window.location.reload();
    } else {
      alert("Failed to update vendor status.");
    }
  } catch (err) {
    console.error("Error updating vendor status:", err);
    alert("Something went wrong while updating vendor status.");
  }
};


 useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        config.BASE_URI + apiPaths.organiserData,
        {
          payload: {
            body: {
              query_type: "fetch_shared_outlet",
              hashcode: hashcode,
            },
          },
        }
      );

      if (response.data.success) {
        const vendorData = response.data.vendors;
        setVendorStatus(vendorData.vendor_status || null);
        setData(vendorData);

      

if (vendorData.timestamp) {
  const parsedDate = moment(vendorData.timestamp, "DD MMM YYYY hh:mm A");
  const now = moment();

  console.log("✅ Raw timestamp:", vendorData.timestamp) ;
  console.log("✅ Parsed date:", parsedDate.format("YYYY-MM-DD HH:mm:ss"));
  console.log("✅ Today:", now.format("YYYY-MM-DD HH:mm:ss"));

  if (parsedDate.isValid()) {
    const diffInDays = now.diff(parsedDate, "days");
    console.log("✅ Diff in days:", diffInDays);

    if (diffInDays >= 90) {
      console.log("🔒 Link expired. Showing modal.");
      setIsLinkExpired(true);
    } else {
      console.log("🔓 Link still valid.");
    }
  } else {
    console.warn("❌ Invalid timestamp format:", vendorData.timestamp);
    
  }
}

      } else {
        setIsLinkExpired(true);
        setError(response.data.err);
      }
    } catch (err) {
      setIsLinkExpired(true);
      setError(err.message);
    }
  };

  fetchData();
}, [hashcode]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!data) {
    return <div>Loading...</div>;
  }
  if (isLinkExpired) {
  return (
    <>
     <Modal show={true} onHide={() => {
    setIsLinkExpired(false);
    window.location.href = "/events";
  }}>
  <Modal.Header closeButton>
    <Modal.Title>Link Expired</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    This vendor link has expired. Would you like to request a new link?
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary"  onClick={() => {
    setIsLinkExpired(false);
    window.location.href = "/events";
  }}>
      Close
    </Button>
    <Button
      variant="primary"
      onClick={async () => {
        try {
          const response = await axios.post(
            config.BASE_URI + apiPaths.organiserData,
            {
              payload: {
                body: {
                  query_type: "request_new_link_share_a_link",
                  hashcode: hashcode,
                },
              },
            }
          );

          if (response.data.success) {
            alert(
              " The vendor has been notified to send you a new link. You will receive it within 1 to 48 hours.\n\n📞 For urgent booking of this truck, call our office at 1300 162 636 or email at hello@wherethetruck.com.au "
            );
            window.location.href = "/events";
          } else {
            alert("⚠️ Failed to request a new link. Please try again later.");
          }
        } catch (err) {
          console.error("Error requesting new link:", err);
          alert("❌ Something went wrong while requesting a new link.");
        }
      }}
    >
      Request New Link
    </Button>
  </Modal.Footer>
</Modal>

    </>
  );
}

  return (
  <>
    <ResponsiveNavBar
      showBack={false}
      backUrl={"/"}
      ticketState={{}}
      products={{}}
      loggedIn={false}
      username={""}
      userd={""}
      dispatch={() => {}}
    />

    <div style={{ position: "relative" }}>
      <div
        style={{
          filter: isLinkExpired ? "blur(5px)" : "none",
          pointerEvents: isLinkExpired ? "none" : "auto",
          opacity: isLinkExpired ? 0.5 : 1,
          transition: "all 0.3s ease-in-out",
        }}
      >
        <Container className="modern-container">
          <img
            className="d-block w-100 hero-image"
            src={require("../../assets/img/wtt.png")}
            alt=""
          />

          {data.status === "Accepted" && (
            <Row>
              <Col md={12}>
                <Card className="modern-card">
                  <Card.Header className="vendor-header modern-header">
                    <h4>Realtime Chat</h4>
                  </Card.Header>
                  <Card.Body>
                    <ChatBox hashcode={firebaseHashcode} userType="organiser" />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {data.status !== "Rejected" && (
            <div className="d-flex justify-content-center gap-3 my-3">
              {data.status !== "Accepted" && (
                <Button variant="success" onClick={() => handleVendorStatus("Accepted")}>✅ Review The Truck & Start A Live Chat</Button>
              )}
              <Button variant="danger" onClick={() => handleVendorStatus("Rejected")}>❌ Reject Vendor</Button>
            </div>
          )}

          {/* Vendor Bio */}
          <Row>
            <Col md={12}>
              <Card className="modern-card">
                <Card.Header className="vendor-header modern-header">
                  {data.vendor__title}
                </Card.Header>
                <Card.Body>
                  <Image
                    src={AWS_URL + "/" + data.vendor__logo}
                    alt={data.vendor__title}
                    fluid
                    className="vendor-image modern-image"
                  />
                  <Card.Text className="modern-text">{data.vendor__bio}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Documents */}
          <Row>
            <Col md={12}>
              <Card className="modern-card">
                <Card.Header className="vendor-header modern-header">
                  <h4>Stall Documents</h4>
                </Card.Header>
                <Card.Body>
                  {data.vendor__food_refistration_docs && (
                    <p><strong>Council Registration Certificate:</strong> <a href={AWS_URL + "/" + data.vendor__food_refistration_docs} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                  {data.vendor__food_safety_certificate && (
                    <p><strong>Food Safety Certificate:</strong> <a href={AWS_URL + "/" + data.vendor__food_safety_certificate} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                  {data.vendor__liablity_certificate && (
                    <p><strong>Public Liability Certificate:</strong> <a href={AWS_URL + "/" + data.vendor__liablity_certificate} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                  {data.vendor__work_cover_insurance && (
                    <p><strong>Work Cover:</strong> <a href={AWS_URL + "/" + data.vendor__work_cover_insurance} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                  {data.operator_shared_statement_of_trade_file && (
                    <p><strong>Statement Of Trade:</strong> <a href={AWS_URL + "/" + data.operator_shared_statement_of_trade_file} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                  {data.vendor__site_layout && (
                    <p><strong>Site Layout:</strong> <a href={AWS_URL + "/" + data.vendor__site_layout} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                  {data.vendor__working_with_childrens_check && (
                    <p><strong>Working With Children's Check:</strong> <a href={AWS_URL + "/" + data.vendor__working_with_childrens_check} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                  {data.vendor__electricial_certificate && (
                    <p><strong>Electrical Certificate:</strong> <a href={AWS_URL + "/" + data.vendor__electricial_certificate} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                  {data.vendor__gas_certificate && (
                    <p><strong>Gas Plate:</strong> <a href={AWS_URL + "/" + data.vendor__gas_certificate} target="_blank" rel="noopener noreferrer">View</a></p>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Images */}
          <Row>
            <Col md={12}>
              <Card className="modern-card">
                <Card.Header className="vendor-header modern-header">
                  <h4>Images</h4>
                </Card.Header>
                <Card.Body>
                  <Carousel>
                    {data.truck_images.map((image, index) => (
                      <Carousel.Item key={index}>
                        <img className="d-block w-100" src={AWS_URL + "/" + image.image} alt={`Truck Images ${index + 1}`} />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                  <Carousel>
                    {data.staff_uniform_images.map((image, index) => (
                      <Carousel.Item key={index}>
                        <img className="d-block w-100" src={AWS_URL + "/" + image.image} alt={`Staff Uniform ${index + 1}`} />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Menu */}
          <Row>
            <Col md={12}>
              <Card className="modern-card">
                <Card.Header className="vendor-header modern-header">
                  <h4>Menu</h4>
                </Card.Header>
                <Card.Body>
                  <div>
                    {data.meals.reduce((acc, meal, index, array) => {
                      if (index % 2 === 0) {
                        acc.push(array.slice(index, index + 2));
                      }
                      return acc;
                    }, []).map((mealPair, idx) => (
                      <Row key={idx}>
                        {mealPair.map((meal) => (
                          <Col md={6} key={meal.id}>
                            <Card className="modern-card">
                              <Card.Header className="vendor-subheader modern-subheader">
                                {meal.name} -- {meal.category__title}
                              </Card.Header>
                              <Card.Body>
                                <Image
                                  className="meal-image modern-meal-image"
                                  src={AWS_URL + "/" + meal.image}
                                  alt={meal.name}
                                  fluid
                                />
                                <Card.Text>{meal.description}</Card.Text>
                                <Card.Text>
                                  Dietary: {meal.diets__title === null ? "Not Specified" : meal.diets__title}
                                </Card.Text>
                                <Card.Text>Price: ${meal.price}</Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {isLinkExpired && (
        <Modal show={true}  onHide={() => {
    setIsLinkExpired(false);
    window.location.href = "/events";
  }} backdrop="static" keyboard={false} centered>
          <Modal.Header>
            <Modal.Title>Link Expired</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            This vendor link has expired. Would you like to request a new link?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={async () => {
  try {
    const response = await axios.post(
      config.BASE_URI + apiPaths.organiserData,
      {
        payload: {
          body: {
            query_type: "request_new_link_share_a_link",
            hashcode: hashcode,
          },
        },
      }
    );

    if (response.data.success) {
      alert(
        "✅ The vendor has been notified to send you a new link. You will receive it within 1 to 48 hours.\n\n📞 For urgent matters, call our office at 1300 162 636."
      );
      window.location.href = "/events";
    } else {
      alert("⚠️ Failed to request a new link. Please try again later.");
    }
  } catch (err) {
    console.error("Error requesting new link:", err);
    alert("❌ Something went wrong while requesting a new link.");
  }
}}
            >
              Request New Link
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>

    <Modal show={isOpenEOIModal} onHide={handleClose}>
      <EOIPage handleClose={handleClose} />
    </Modal>

    <Footer />
  </>
);
};
export default SharedOutlet;
